import { toRefs } from '@vueuse/core'
import type { FinancialCommon, Nullable, Plan } from '~/types'

export default function useFinancialData(data?: Ref<Nullable<FinancialCommon> | undefined>) {
  const financialData = computed(() => getFinancial(data?.value))

  function getProtectionPlans(isValidForStationaryPlan: boolean): Plan[] {
    const {
      financialTotalNights,

      financialNightlyInsuranceRateBasic,
      financialNightlyRoadsideBasicRate,
      financialDeductibleAmountBasic,

      financialNightlyInsuranceRateStandard,
      financialNightlyRoadsideStandardRate,
      financialDeductibleAmountStandard,

      financialNightlyInsuranceRatePremium,
      financialNightlyRoadsidePremiumRate,
      financialDeductibleAmountPremium,

      financialNightlyInsuranceRateStationary,
      financialNightlyRoadsideStationaryRate,
      financialDeductibleAmountStationary,

      financialNightlyInsuranceRateStationaryPlus,
      financialNightlyRoadsideStationaryPlusRate,
      financialDeductibleAmountStationaryPlus,
    } = financialData.value

    if (isValidForStationaryPlan) {
      const pricePerNightStationary = financialNightlyInsuranceRateStationary + financialNightlyRoadsideStationaryRate
      const pricePerNightStationaryPlus = financialNightlyInsuranceRateStationaryPlus + financialNightlyRoadsideStationaryPlusRate

      return [{
        name: 'Stationary' as Plan['name'],
        pricePerNight: roundToNearestCent(pricePerNightStationary),
        priceTotal: roundToNearestCent(pricePerNightStationary * financialTotalNights),
        deductible: financialDeductibleAmountStationary,
      },
      {
        name: 'StationaryPlus' as Plan['name'],
        pricePerNight: roundToNearestCent(pricePerNightStationaryPlus),
        priceTotal: roundToNearestCent(pricePerNightStationaryPlus * financialTotalNights),
        deductible: financialDeductibleAmountStationaryPlus,
      }]
    }

    const pricePerNightBasic = financialNightlyInsuranceRateBasic + financialNightlyRoadsideBasicRate
    const pricePerNightStandard = financialNightlyInsuranceRateStandard + financialNightlyRoadsideStandardRate
    const pricePerNightPremium = financialNightlyInsuranceRatePremium + financialNightlyRoadsidePremiumRate

    return [{
      name: 'Basic',
      pricePerNight: roundToNearestCent(pricePerNightBasic),
      priceTotal: roundToNearestCent(pricePerNightBasic * financialTotalNights),
      deductible: financialDeductibleAmountBasic,
    },
    {
      name: 'Standard',
      pricePerNight: roundToNearestCent(pricePerNightStandard),
      priceTotal: roundToNearestCent(pricePerNightStandard * financialTotalNights),
      deductible: financialDeductibleAmountStandard,
    },
    {
      name: 'Premium',
      pricePerNight: roundToNearestCent(pricePerNightPremium),
      priceTotal: roundToNearestCent(pricePerNightPremium * financialTotalNights),
      deductible: financialDeductibleAmountPremium,
    }]
  }

  return {
    ...toRefs(financialData),
    getProtectionPlans,
  }
}
